<template>
  <div class="container">
    <h1>客户端检测测试</h1>
    
    <div class="client-info" id="clientInfo" :class="clientInfoClass">
      {{ clientInfoText }}
    </div>
    
    <button @click="detectClient">重新检测</button>
    <button @click="detectClientFrontend">前端检测</button>
    
    <div class="result" :class="resultClass" v-if="result.message" v-html="result.message"></div>
    
    <h2>说明</h2>
    <p>此页面用于测试客户端检测功能：</p>
    <ul>
      <li><strong>后端检测</strong>：通过User-Agent请求头发送到服务器进行检测</li>
      <li><strong>前端检测</strong>：直接在浏览器中通过JavaScript检测User-Agent</li>
    </ul>
    
    <h3>检测结果说明</h3>
    <ul>
      <li><span class="wechat">绿色</span>：微信客户端</li>
      <li><span class="alipay">蓝色</span>：支付宝客户端</li>
      <li><span class="browser">黄色</span>：普通浏览器</li>
    </ul>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'ClientDetect',
  data() {
    return {
      clientInfo: {
        type: '',
        text: '检测中...'
      },
      result: {
        type: '',
        message: ''
      }
    };
  },
  computed: {
    clientInfoClass() {
      switch(this.clientInfo.type) {
        case 'wechat': return 'wechat';
        case 'alipay': return 'alipay';
        default: return 'browser';
      }
    },
    clientInfoText() {
      return this.clientInfo.text;
    },
    resultClass() {
      return this.result.type === 'success' ? 'success' : 'error';
    }
  },
  mounted() {
    this.detectClient();
  },
  methods: {
    async detectClient() {
      this.clientInfo = {
        type: '',
        text: '检测中...'
      };
      this.result = { type: '', message: '' };
      
      try {
        const response = await api.get('/yisheng/detect-client');
        const data = response.data;
        const clientType = data.clientType;
        
        // 更新显示信息
        this.updateClientInfo(clientType, '后端');
        
        // 显示详细结果
        this.result = {
          type: 'success',
          message: '<h3>检测结果</h3><pre>' + JSON.stringify(data, null, 2) + '</pre>'
        };
      } catch (error) {
        console.error('后端检测失败:', error);
        this.clientInfo = {
          type: 'browser',
          text: '后端检测失败: ' + error.message
        };
        
        this.result = {
          type: 'error',
          message: '<h3>错误信息</h3><pre>' + error.message + '</pre>'
        };
      }
    },
    detectClientFrontend() {
      const clientType = this.detectClientType();
      
      // 更新显示信息
      this.updateClientInfo(clientType, '前端');
      
      // 显示详细结果
      const data = {
        clientType: clientType,
        userAgent: navigator.userAgent
      };
      
      this.result = {
        type: 'success',
        message: '<h3>检测结果</h3><pre>' + JSON.stringify(data, null, 2) + '</pre>'
      };
    },
    detectClientType() {
      const ua = window.navigator.userAgent.toLowerCase();
      
      if (ua.includes('micromessenger')) {
        return 'wechat';
      } else if (ua.includes('alipayclient')) {
        return 'alipay';
      } else {
        return 'browser';
      }
    },
    updateClientInfo(clientType, detectionMethod) {
      switch(clientType) {
        case 'wechat':
          this.clientInfo = {
            type: 'wechat',
            text: detectionMethod + '检测到您正在使用微信客户端'
          };
          break;
        case 'alipay':
          this.clientInfo = {
            type: 'alipay',
            text: detectionMethod + '检测到您正在使用支付宝客户端'
          };
          break;
        default:
          this.clientInfo = {
            type: 'browser',
            text: detectionMethod + '检测到您正在使用普通浏览器'
          };
      }
    }
  }
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f5f5;
}
.container {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
h1 {
  color: #333;
  text-align: center;
}
.result {
  margin: 20px 0;
  padding: 15px;
  border-radius: 5px;
}
.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.client-info {
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 5px;
  padding: 15px;
  margin: 20px 0;
  text-align: center;
  font-weight: bold;
}
.wechat {
  background-color: #c8e6c9;
  border-color: #4caf50;
  color: #2e7d32;
}
.alipay {
  background-color: #e1f5fe;
  border-color: #03a9f4;
  color: #0288d1;
}
.browser {
  background-color: #ffecb3;
  border-color: #ffc107;
  color: #ff9800;
}
button {
  background-color: #007bff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin: 10px 0;
}
button:hover {
  background-color: #0056b3;
}
pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 15px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>